import React, { useEffect, useRef, useState, useContext, useMemo } from "react";
import { Helmet } from "react-helmet-async";
import { Footer2 } from "../../../footer2/index";
import ImageModal from "./ImageModal";
import { Link } from "react-router-dom";
import { Chapter, Chart, Cloud, Icon1, Icon2, Import, Key, Mobile, People, Play, Teacher, Timer2, User1, Users, Video, Video2, Timer } from "../../../imagepath";
import FeatherIcon from "feather-icons-react";
import { publicationdetail, publicationSuggestion, publicationsearchdetailDTO } from "../../../../services/publicationService";
import { AppContext } from "../../../../services/AuthContext";
import { useParams } from "react-router-dom";
import { buildPublicationPath, extractIdFromSlug } from "../../../../utils/slugify";
import axiosInstance from "../../../../services/axiosInstance";
import { Modal, Button, Spinner } from 'react-bootstrap';
import { publisherDetail } from '../../../../services/publisherService';
import JournalAbout from "./JournalAbout";
import BookAbout from "./BookAbout";
import SubPubAbout from "./SubPubAbout";
import SubPubHeaderInfo from "./SubPubHeaderInfo";
import PreviousIssues from "./PreviousIssues";
import LatestIssue from "./LatestIssue";
import Header from "../../../header/index";
import { useLocation, useNavigate } from "react-router-dom";
import JournalHeaderInfo from "./JournalHeaderInfo"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { userInstutationDatabases } from "../../../../services/userService";
import SaveModal from "../courseList/components/SaveModal";
import BookHeaderInfo from "./BookHeaderInfo";
import PdfAcrobatIcon from "../courseList/components/PdfAcrobatIcon";
import { getFilePath } from "../../../../services/axiosInstance";
import usePageTracking from "../../../../hooks/usePageTracking";


function formatDateTR(dateString) {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;
    const aylar = [
        "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
        "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
    ];
    return `${date.getDate()} ${aylar[date.getMonth()]} ${date.getFullYear()}`;
}

// Okuyucu Kitlesi vb. ortak alanı çekmek için küçük yardımcı
const extractFromInfo = (ej, name) =>
    ej?.publicationtypeInfo?.find(a => a.attributename === name)?.value?.[0]?.value?.[0] ||
    ej?.templateInfo?.find(a => a.attributename === name)?.value?.[0]?.value?.[0] || null;

const getAvailableLanguages = (ej) => {
    const languages = new Set();
    [...(ej?.publicationtypeInfo || []), ...(ej?.templateInfo || [])].forEach((info) => {
        info.value?.forEach((val) => {
            if (val.lang && Array.isArray(val.value) && val.value.some((v) => v !== "")) {
                languages.add(String(val.lang));
            }
        });
    });
    return Array.from(languages);
};

// field çekme – lang destekli
const getField = (ej, name, lang) => {
    if (!ej) return null;
    const pick = (arr) =>
        arr?.find(a => a.attributename === name)?.value || [];
    const pti = pick(ej.publicationtypeInfo || []);
    const ti = pick(ej.templateInfo || []);
    const items = [...pti, ...ti];
    if (!items.length) return null;

    if (lang) {
        const found = items.find(v => String(v?.lang || "").toLowerCase() === String(lang).toLowerCase());
        // Eğer dile göre arıyorsak ve birden fazla değer varsa dizi olarak döndür
        if (found?.value?.length > 1) return found.value;
        return found?.value?.[0] ?? null;
    }

    // ISBN/ISSN gibi alanlar genellikle birden fazla dil bloğuna yayılmış olabilir
    // Tüm dillerdeki tüm "value" dizilerini tek bir dizide toplayalım
    const allValues = items.flatMap(item => item.value || []);

    // Eğer tek değer varsa string, birden fazla varsa dizi döndür
    if (allValues.length > 1) return allValues;
    return allValues[0] ?? null;
};

const getPublishersPretty = (infos, fallback) => {
    if (infos?.length) return infos.map(p => ({ id: p.id, name: p.name, shortName: p.shortName }));
    if (Array.isArray(fallback) && fallback.length)
        return fallback.map(p => ({ id: p.mysqlId, name: p.title || '-', shortName: p.sorttitle }));
    return [];
};

// Tüm geçerli ve boş olmayan başlıkları (dil bilgisiyle birlikte) toplayan fonksiyon
const getValidTitles = (ej, name = "Başlık") => {
    if (!ej) return [];

    const pick = (arr) => arr?.find(a => a.attributename === name)?.value || [];
    const pti = pick(ej.publicationtypeInfo || []);
    const ti = pick(ej.templateInfo || []);
    const items = [...pti, ...ti];

    const validTitles = [];
    const seen = new Set();

    for (const item of items) {
        const titleValues = item?.value;
        if (Array.isArray(titleValues)) {
            for (const text of titleValues) {
                if (text && String(text).trim() !== "") {
                    const cleanText = String(text).replace(/\s*\/$/, '').trim();
                    const lowerText = cleanText.toLowerCase();

                    if (!seen.has(lowerText)) {
                        seen.add(lowerText);
                        validTitles.push({
                            lang: item?.lang ? String(item.lang).toLowerCase() : null,
                            title: cleanText
                        });
                    }
                }
            }
        }
    }
    return validTitles;
};


const databasesPretty = (ej) => {
    if (!ej || !Array.isArray(ej.databases)) return [];
    const names = ej.databases.map(db => {
        const name = (typeof db === "string" ? db : (db.name || db.title || ""));
        const lowerName = String(name).toLowerCase();
        if (lowerName.includes("akademik dergiler") || lowerName.includes("popüler dergiler")) {
            return "İdealonline süreli yayınlar";
        }
        return name;
    }).filter(Boolean);
    return [...new Set(names)];
};

const deriveAccessType = (ej) => {
    // protectedaccess = 1 ise her zaman korumalı
    if (Number(ej?.protectedaccess) === 1) {
        return "Korumalı Erişim";
    }

    // değilse openaccess değerine göre karar ver
    const val = Number(ej?.openaccess);
    if (val === 0) return "Kapalı Erişim";  // ama aslında protectedaccess 1 değilse "Abonelik/Korumalı"
    if (val === 1) return "Açık Erişim";
    if (val === 2) return "Karma Erişim";

    return null; // tanımsızsa
};


const CourseDetails = () => {
    usePageTracking("publication");
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [open3, setOpen3] = useState(false);
    const [open4, setOpen4] = useState(false);

    const { auth } = useContext(AppContext);
    const params = useParams();
    // support both legacy id route and new SEO slug route
    const id = params.id || extractIdFromSlug(params.slug);
    const [publicationType, setPublicationType] = useState(null);
    const [publication, setPublication] = useState(null);
    const [similarPublications, setSimilarPublications] = useState([]);
    const [parentDetails, setParentDetails] = useState({});
    const [editors, setEditors] = useState([]);
    const [publishers, setPublishers] = useState([]);
    const headers = auth.token
        ? {
            Authorization: `Bearer ${auth.token}`,
        }
        : "";
    const [subPublications, setSubPublications] = useState([]);
    const [showImageModal, setShowImageModal] = useState(false);

    const [publisherNames, setPublisherNames] = useState([]);
    const [publisherInfos, setPublisherInfos] = useState([]);
    const [parentJournal, setParentJournal] = useState(null);
    const location = useLocation();
    const [publicationAudience, setPublicationAudience] = useState(null);
    const [dbMap, setDbMap] = useState({});
    // favori ve kurum DB’leri
    const [userDatabase, setUserDatabase] = useState([]);
    const [favoriteSavedIds, setFavoriteSavedIds] = useState([]);
    const [ipDbMap, setIpDbMap] = useState({});
    const [errorMessage, setErrorMessage] = useState(null);
    const [showSaveModal, setShowSaveModal] = useState(false);
    const [saveSummary, setSaveSummary] = useState({ total: 0, added: 0, existing: 0 });
    const [singlePublicationId, setSinglePublicationId] = useState(null);
    const [kaydetSelectedFolders, setKaydetSelectedFolders] = useState([]);
    const [kaydetFolders, setKaydetFolders] = useState([1]);
    const [foldersLoading, setFoldersLoading] = useState(false);
    const [selectedArticles, setSelectedArticles] = useState([]);

    const [latestIssueCover, setLatestIssueCover] = useState(null);
    const [latestIssueId, setLatestIssueId] = useState(null);

    const [absoluteLatestYear, setAbsoluteLatestYear] = useState(null);

    // dosyanın üstlerine bir yere ekle
    function splitPeopleByJob(list) {
        const res = { authors: [], editors: [], translator: [] };
        (Array.isArray(list) ? list : []).forEach(p => {
            const job = String(p?.job || "").trim().toLowerCase();
            if (job === "yazar" || job === "author") res.authors.push(p);
            else if (job === "editör" || job === "editor") res.editors.push(p);
            else if (job === "çeviren" || job === "ceviren") res.translator.push(p);
        });
        return res;
    }


    const databasesPretty = React.useCallback(
        (ej) => {
            // Yayının üzerindeki DB ID’lerini topla
            const ids = (ej?.databases || [])
                .map(d => Number(d?.mysqlId ?? d?.id))
                .filter(n => Number.isFinite(n));

            if (ids.length === 0) return [];

            // Sadece dbMap'i kullan
            return [...new Set(ids.map(id => dbMap[id]).filter(Boolean))];
        },
        [dbMap]
    );


    const getFavoritePublications = async () => {
        try {
            const res = await axiosInstance.get(
                "userpanel/favoritepublicationsListByUserId/1",
                { headers }
            );
            if (res.data?.status === "OK") {
                setFavoriteSavedIds(res.data.data.map(item => String(item.publication.id)));
            }
        } catch (err) {
            // sessiz geç
            console.error("Favoriler alınamadı:", err);
        }
    };

    useEffect(() => {
        const loadIpDatabases = async () => {
            try {
                const response = await userInstutationDatabases(auth?.token);
                const payload = response?.data ?? response ?? [];
                // Beklenen şekil: [{ id, name }, ...]
                const map =
                    Array.isArray(payload)
                        ? Object.fromEntries(
                            payload
                                .map(x => [Number(x?.id), x?.name])
                                .filter(([id, name]) => Number.isFinite(id) && !!name)
                        )
                        : {};
                setIpDbMap(map);
            } catch {
                setIpDbMap({});
            }
        };
        loadIpDatabases();
    }, [auth?.token]);




    useEffect(() => {
        if (auth?.token) getFavoritePublications();
    }, [auth?.token]);

    const handleAddToFavorites = async (pub) => {
        try {
            const response = await axiosInstance.post(
                "userpanel/favoritepublicationsAdd",
                {
                    userid: auth.id,
                    publicationid: pub.mysqlId,
                    status: 1
                },
                {
                    headers: {
                        Authorization: `Bearer ${auth.token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            toast.success(response.data.message || "Kütüphaneye başarıyla eklendi.");
            setSaveSummary({
                total: 1,
                added: 1,
                existing: 0,
            });
            setShowSaveModal(true); // sonra modalı aç
        } catch (error) {
            const errorMsg =
                error?.response?.data?.message || "Bir hata oluştu. Lütfen tekrar deneyin.";
            toast.error(errorMsg);
            console.error("Kütüphaneye ekleme hatası:", error);
            setSaveSummary({
                total: 1,
                added: 0,
                existing: 1,
            });
            setShowSaveModal(true); // sonra modalı aç

        }
    };

    const handleSingleSaveWithModal = async (pub) => {
        try {
            await handleAddToFavorites(pub); // önce favorilere ekle

            setSinglePublicationId(pub.mysqlId);

            await getFavoritePublications(); // favorileri güncelle

        } catch (err) {
            console.error("Tekli favoriye ekleme hatası:", err);
        }
    };
    const handleCreateFolder = async (folderName) => {
        try {
            await axiosInstance.post(
                "userpanel/userworkfolderCreate",
                { foldername: folderName, description: "" },
                { headers: { Authorization: `Bearer ${auth.token}` } }
            );
            toast.success("Klasör oluşturuldu");
            fetchFolders(); // tekrar yükle
        } catch (err) {
            toast.error("Klasör oluşturulamadı.");
        }
    };
    const fetchFolders = async () => {
        setFoldersLoading(true);
        try {
            const response = await axiosInstance.post(
                "userpanel/userworkfoldersSearch?page=0&size=100",
                { searchkeyword: "" },
                { headers: { Authorization: `Bearer ${auth.token}` } }
            );
            setKaydetFolders(response.data.data || []);
        } catch (err) {
            console.error("Klasörler yüklenemedi.", err);
        }
        setFoldersLoading(false);
    };

    const handleToggleFolder = (folderId, checked) => {
        setKaydetSelectedFolders(prev =>
            checked ? [...prev, folderId] : prev.filter(id => id !== folderId)

        );
        if (checked) {
            handleAddPublicationsToFolder(folderId); // sadece ekleme durumunda çağır
        }
    };

    const handleAddPublicationsToFolder = async (folderId) => {
        if (selectedArticles.length === 0) {
            if (singlePublicationId > 0) {
                const singlePayload = {
                    userworkfolderid: folderId,
                    publicationid: singlePublicationId // 👈 sadece tekli ID burada
                };

                try {
                    const response = await axiosInstance.post(
                        "userpanel/userworkfolderspublicationsCreate",
                        singlePayload,
                        {
                            headers: {
                                Authorization: `Bearer ${auth.token}`,
                                "Content-Type": "application/json",
                            },
                        }
                    );

                    const result = response.data;

                    if (result?.status === "alreadyExists") {
                        toast.info("Bu yayın zaten klasörde kayıtlı.");
                    } else {
                        toast.success("Yayın klasöre kaydedildi.");
                    }

                    setKaydetSelectedFolders((prev) =>
                        prev.includes(folderId) ? prev : [...prev, folderId]
                    );

                } catch (err) {
                    toast.error("Klasöre eklenirken bir hata oluştu. (Yayın bu dosyada zaten kayıtlı olabilir)");
                    console.error(err);
                }

                return; // multiple işlemini atla

            }
            toast.info("Lütfen önce eklemek istediğiniz yayınları seçin.");
            return;
        }

        const payload = selectedArticles.map((pubId) => ({
            userworkfolderid: folderId,
            publicationid: Number(pubId),
        }));

        try {
            const response = await axiosInstance.post(
                "userpanel/userworkfolderspublicationsCreateList",
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${auth.token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            const count = response.data?.count;

            if (count === 0) {
                toast.info("Seçilen yayınlar zaten bu klasörde kayıtlı.");
            } else {
                toast.success(`${count} yayın klasöre kaydedildi.`);
            }

            setKaydetSelectedFolders((prev) =>
                prev.includes(folderId) ? prev : [...prev, folderId]
            );

        } catch (err) {
            toast.error("Klasöre eklenirken bir hata oluştu.");
            console.error(err);
        }
    };

    const handleAddSinglePublicationToFolder = async (folderId, publicationid) => {
        if (!publicationid || !folderId) return;

        try {
            const response = await axiosInstance.post(
                "userpanel/userworkfolderspublicationsCreate",
                {
                    userworkfolderid: folderId,
                    publicationid: Number(publicationid),
                },
                {
                    headers: {
                        Authorization: `Bearer ${auth.token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            toast.success("Yayın klasöre kaydedildi.");

            setKaydetSelectedFolders((prev) =>
                prev.includes(folderId) ? prev : [...prev, folderId]
            );
        } catch (err) {
            toast.error("Zaten bu klasörde olabilir.");
            console.error(err);
        }
    };


    useEffect(() => {
        const loadUserDatabase = async () => {
            try {
                const response = await userInstutationDatabases(auth.token);
                const names = response.data.map((item) => item.name);
                setUserDatabase(names);
                setErrorMessage(null);
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    setErrorMessage(error.response.data.message);
                } else {
                    setErrorMessage("Bir hata oluştu. Lütfen tekrar deneyin.");
                }
                setUserDatabase([]); // Hata olursa yine array olarak bırakıyoruz
            }
        };
        loadUserDatabase();
    }, [auth.token]);




    useEffect(() => {
        const loadDbMap = async () => {
            try {
                const res = await axiosInstance.get(
                    "databases/search/databaseList/1",
                );
                const list = Array.isArray(res?.data?.data) ? res.data.data : [];
                const map = Object.fromEntries(list.map(d => [Number(d.id), d.name]));
                setDbMap(map);
            } catch (e) {
                console.error("DB listesi alınamadı:", e);
                setDbMap({});
            }
        };
        loadDbMap();
    }, [auth?.token]); // token değişirse tekrar dener

    useEffect(() => {
        if (auth?.token) getFavoritePublications();
    }, [id, auth?.token]);

    const [openItem, setOpenItem] = useState(0);

    const toggleItem = (id) => {
        setOpenItem((prev) => (prev === id ? id : id));
    };

    useEffect(() => {
        if (auth.token) {
            fetchFolders();
            getFavoritePublications();
        }
    }, []);

    const hasFetchedHit = useRef(null);

    useEffect(() => {
        let isCancelled = false;

        const initData = async () => {
            if (!id) return;

            // redirect bileşeninden veri geldiyse ve id aynıysa tekrar API'ye gitme
            if (location.state?.preFetchedData && location.state?.preFetchedData?.mysqlId === Number(id)) {
                const data = location.state.preFetchedData;
                setPublication(data);
                setPublicationType(data.publicationtype);
                // Parent/Journal bilgilerini çekmek için devam et
                handleHiearchy(data);
                hasFetchedHit.current = id;
                return;
            }

            // İstatistik güvenliği: Aynı ID için bu mount süresince 2. kez çağırma
            if (hasFetchedHit.current === id) return;

            try {
                console.log("Fetching Main Publication...");
                // Ziyaret kaydı için ek sorgu
                publicationsearchdetailDTO(id, auth.token || "").catch(e => console.error("Log error:", e));

                const response = await publicationdetail(id, auth.token || "");
                if (isCancelled) return;

                const pubData = response.data.elasticjson;

                // PDF Yönlendirme iptal edildi, artık detay sayfasına gidilecek.

                setPublication(pubData);
                setPublicationType(pubData.publicationtype);
                hasFetchedHit.current = id; // Başarıyla yüklendi işareti

                // Hiyerarşiyi (Dergi bilgilerini) çöz
                handleHiearchy(pubData);

            } catch (error) {
                console.error("Yükleme hatası:", error);
            }
        };

        // Hiyerarşi ve Parent çekme mantığını buraya ayırdık
        const handleHiearchy = async (pubData) => {
            if (pubData.parentid) {
                const pDetails = await fetchParentDetails(pubData.parentid, auth.token);
                if (isCancelled) return;
                setParentDetails(pDetails);

                // Eğer hiyerarşide bir Dergi bulunduysa parentJournal'a set et
                if (pDetails?.parentElastic) {
                    setParentJournal(pDetails.parentElastic);
                }
            } else if (String(pubData.publicationtype).toLowerCase() === "dergi") {
                // Kendisi zaten dergi ise
                setParentJournal(pubData);
            }
        };

        initData();

        return () => {
            isCancelled = true;
        };
    }, [id, auth.token, location.state]);

    // denemelik kitap yerine dergi yazıyoruz
    useEffect(() => {
        const loadSimilarPublications = async () => {
            try {

                const suggestionData = await publicationSuggestion(auth.token, {
                    title: publication.publicationtypeInfo.find(attr => attr.attributename === "Başlık")?.value[0]?.value[0] ||
                        publication.templateInfo.find(attr => attr.attributename === "Başlık")?.value[0]?.value[0] || "",


                    summary: publication?.publicationtypeInfo
                        .find((attr) => attr.attributename === "Özet")
                        ?.value.find((val) => val.lang === "tr")?.value[0]
                        || "",
                    keywords: publication?.publicationtypeInfo
                        .find((attr) => attr.attributename === "Anahtar Kelimeler")
                        ?.value.find((val) => val.lang === "tr")?.value?.join(", ") || "",
                    publicationid: publication?.mysqlId || "",

                    publicationtype: publication?.publicationtype || "",
                });
                setSimilarPublications(suggestionData?.data);
            } catch (error) {
                console.error("Error fetching similar publications or suggestions:", error);
                setSimilarPublications([])
            }
        };

        loadSimilarPublications();
    }, [auth.token, publication]);


    const fetchParentDetails = async (parentId, token) => {
        let currentParentId = parentId;
        let result = {};

        while (currentParentId) {
            try {
                console.log("parentcalleeddd")
                const response = await publicationdetail(currentParentId, token);
                const data = response?.data?.elasticjson;
                if (!data) break;

                let titleRaw =
                    data.publicationtypeInfo?.find(a => a.attributename === "Başlık")?.value?.[0]?.value?.[0] ||
                    data.templateInfo?.find(a => a.attributename === "Başlık")?.value?.[0]?.value?.[0];
                const title = typeof titleRaw === 'string' ? titleRaw.replace(/\s*\/$/, '').trim() : (titleRaw || result.title);

                const volume =
                    data.publicationtypeInfo?.find(a => a.attributename === "Cilt")?.value?.[0]?.value?.[0] || result.volume;

                const issue =
                    data.publicationtypeInfo?.find(a => a.attributename === "Sayı")?.value?.[0]?.value?.[0] || result.issue;

                const issn =
                    data.publicationtypeInfo?.find(a => a.attributename === "ISSN")?.value?.[0]?.value?.[0] || result.issn;

                const publisher = Array.isArray(data.publishers) ? data.publishers : (result.publisher || []);

                const editorText =
                    data.publicationtypeInfo?.find(a => a.attributename === "Editör")?.value?.find(v => v.lang === "tr")?.value?.[0] ||
                    data.templateInfo?.find(a => a.attributename === "Editör")?.value?.find(v => v.lang === "tr")?.value?.[0] ||
                    "";

                const parentAuthors = Array.isArray(data.authors) ? data.authors : [];

                const audienceHere =
                    data.publicationtypeInfo?.find(a => a.attributename === "Okuyucu Kitlesi")?.value?.[0]?.value?.[0] ||
                    data.templateInfo?.find(a => a.attributename === "Okuyucu Kitlesi")?.value?.[0]?.value?.[0] ||
                    null;

                // Seri bilgileri: bazı yayınlarda bu alanlar farklı template veya publicationtypeInfo içinde yer alır.
                // Aşağıdaki dört değişken; "Seri Adı", "Seri Numarası", "Alt Seri Adı", "Alt Seri Numarası" attributelarını
                // güvenli şekilde çekip (öncelik publicationtypeInfo, sonra templateInfo) result'a ekler.
                const seriesName =
                    data.publicationtypeInfo?.find(a => a.attributename === "Seri Adı")?.value?.[0]?.value?.[0] ||
                    data.templateInfo?.find(a => a.attributename === "Seri Adı")?.value?.[0]?.value?.[0] ||
                    result.seriesName || null;

                const seriesNumber =
                    data.publicationtypeInfo?.find(a => a.attributename === "Seri Numarası")?.value?.[0]?.value?.[0] ||
                    data.templateInfo?.find(a => a.attributename === "Seri Numarası")?.value?.[0]?.value?.[0] ||
                    result.seriesNumber || null;

                const subseriesName =
                    data.publicationtypeInfo?.find(a => a.attributename === "Alt Seri Adı")?.value?.[0]?.value?.[0] ||
                    data.templateInfo?.find(a => a.attributename === "Alt Seri Adı")?.value?.[0]?.value?.[0] ||
                    result.subseriesName || null;

                const subseriesNumber =
                    data.publicationtypeInfo?.find(a => a.attributename === "Alt Seri Numarası")?.value?.[0]?.value?.[0] ||
                    data.templateInfo?.find(a => a.attributename === "Alt Seri Numarası")?.value?.[0]?.value?.[0] ||
                    result.subseriesNumber || null;

                result = {
                    title,
                    volume,
                    issue,
                    issn,
                    publisher,
                    // Seri bilgileri
                    seriesName,
                    seriesNumber,
                    subseriesName,
                    subseriesNumber,
                    mysqlId: data.mysqlId || result.mysqlId,
                    publicationtype: data.publicationtype || result.publicationtype,
                    parentAuthors,
                    parentEditorText: editorText,
                    audience: audienceHere || result.audience,
                    // ⬇️ dergi veya konferans seviyesine ulaşınca parent’ın tam elasticjson’unu da taşı
                    parentElastic: result.parentElastic || (
                        (String(data.publicationtype).toLowerCase() === "dergi" || 
                         String(data.publicationtype).toLowerCase() === "konferans ve armağan") 
                        ? data : null
                    ),
                    coverimage: result.coverimage || data.coverimage,
                    mysqlIdForCover: result.mysqlIdForCover || data.mysqlId,
                };

                if (String(data.publicationtype).toLowerCase() === "dergi") break;

                currentParentId = data.parentid;
            } catch (err) {
                console.error(`Error fetching parent details for ${currentParentId}:`, err);
                break;
            }
        }

        return result;
    };

    const [openSections, setOpenSections] = useState({});

    const publications = [];

    const toggleSection = (index) => {
        setOpenSections((prev) => ({ ...prev, [index]: !prev[index] }));
    };


    const citationFormats = {
        bibtex: (pub) => `
        @article{${pub.publicationtypeInfo.find(attr => attr.attributename === "Başlık")?.value[0]?.value[0] ||
            pub.templateInfo.find(attr => attr.attributename === "Başlık")?.value[0]?.value[0].replace(/\s/g, '_')},
          title={${pub.publicationtypeInfo.find(attr => attr.attributename === "Başlık")?.value[0]?.value[0] ||
            pub.templateInfo.find(attr => attr.attributename === "Başlık")?.value[0]?.value[0]}},
          author={${pub.authors?.map(author => `${author.name} ${author.surname}`).join(", ")}},
          year={${pub.publicationtypeInfo.find(attr => attr.attributename === 'Yayın Tarihi')?.value[0]?.value[0]?.split(" ")[0] ||
            pub.templateInfo.find(attr => attr.attributename === 'Yayın Tarihi')?.value[0]?.value[0]?.split(" ")[0]}},
          journal={${parentTitles[pub.mysqlId] || 'Unknown Journal'}}
        }
      `,
        apa: (pub) => `
        ${pub.authors?.map(author => `${author.name} ${author.surname}`).join(", ")}. (${pub.publicationtypeInfo.find(attr => attr.attributename === 'Yayın Tarihi')?.value[0]?.value[0]?.split(" ")[0] ||
            pub.templateInfo.find(attr => attr.attributename === 'Yayın Tarihi')?.value[0]?.value[0]?.split(" ")[0]}). ${pub.publicationtypeInfo.find(attr => attr.attributename === "Başlık")?.value[0]?.value[0] ||
            pub.templateInfo.find(attr => attr.attributename === "Başlık")?.value[0]?.value[0]}. ${parentTitles[pub.mysqlId] || 'Unknown Journal'}.
      `,
        vancouver: (pub) => `
        ${pub.authors?.map(author => `${author.name} ${author.surname}`).join(", ")}. ${pub.publicationtypeInfo.find(attr => attr.attributename === "Başlık")?.value[0]?.value[0] ||
            pub.templateInfo.find(attr => attr.attributename === "Başlık")?.value[0]?.value[0]}. ${parentTitles[pub.mysqlId] || 'Unknown Journal'}. ${pub.publicationtypeInfo.find(attr => attr.attributename === 'Yayın Tarihi')?.value[0]?.value[0]?.split(" ")[0] ||
            pub.templateInfo.find(attr => attr.attributename === 'Yayın Tarihi')?.value[0]?.value[0]?.split(" ")[0]}.
      `,
        harvard: (pub) => `
        ${pub.authors?.map(author => `${author.name} ${author.surname}`).join(", ")} (${pub.publicationtypeInfo.find(attr => attr.attributename === 'Yayın Tarihi')?.value[0]?.value[0]?.split(" ")[0] ||
            pub.templateInfo.find(attr => attr.attributename === 'Yayın Tarihi')?.value[0]?.value[0]?.split(" ")[0]}) '${pub.publicationtypeInfo.find(attr => attr.attributename === "Başlık")?.value[0]?.value[0] ||
            pub.templateInfo.find(attr => attr.attributename === "Başlık")?.value[0]?.value[0]}', ${parentTitles[pub.mysqlId] || 'Unknown Journal'}.
      `,
        mla: (pub) => `
        ${pub.authors?.map(author => `${author.name} ${author.surname}`).join(", ")}. "${pub.publicationtypeInfo.find(attr => attr.attributename === "Başlık")?.value[0]?.value[0] ||
            pub.templateInfo.find(attr => attr.attributename === "Başlık")?.value[0]?.value[0]}." ${parentTitles[pub.mysqlId] || 'Unknown Journal'}, ${pub.publicationtypeInfo.find(attr => attr.attributename === 'Yayın Tarihi')?.value[0]?.value[0]?.split(" ")[0] ||
            pub.templateInfo.find(attr => attr.attributename === 'Yayın Tarihi')?.value[0]?.value[0]?.split(" ")[0]}.
      `,
        chicago: (pub) => `
        ${pub.authors?.map(author => `${author.name} ${author.surname}`).join(", ")}. "${pub.publicationtypeInfo.find(attr => attr.attributename === "Başlık")?.value[0]?.value[0] ||
            pub.templateInfo.find(attr => attr.attributename === "Başlık")?.value[0]?.value[0]}." ${parentTitles[pub.mysqlId] || 'Unknown Journal'}, ${pub.publicationtypeInfo.find(attr => attr.attributename === 'Yayın Tarihi')?.value[0]?.value[0]?.split(" ")[0] ||
            pub.templateInfo.find(attr => attr.attributename === 'Yayın Tarihi')?.value[0]?.value[0]?.split(" ")[0]}.
      `,
        ieee: (pub) => `
        ${pub.authors?.map(author => `${author.name} ${author.surname}`).join(", ")}, "${pub.publicationtypeInfo.find(attr => attr.attributename === "Başlık")?.value[0]?.value[0] ||
            pub.templateInfo.find(attr => attr.attributename === "Başlık")?.value[0]?.value[0]}," in ${parentTitles[pub.mysqlId] || 'Unknown Journal'}, vol. ${pub.volume || 'N/A'}, no. ${pub.issue || 'N/A'}, pp. ${pub.pages || 'N/A'}, ${pub.publicationtypeInfo.find(attr => attr.attributename === 'Yayın Tarihi')?.value[0]?.value[0]?.split(" ")[0] ||
            pub.templateInfo.find(attr => attr.attributename === 'Yayın Tarihi')?.value[0]?.value[0]?.split(" ")[0]}.
      `,
    };

    // Open Modal
    const handleOpenModal = (publication) => {
        setSelectedPublication(publication);
        setShowModal(true);
    };

    // Close Modal
    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedFormat('');
    };

    // Render Citation
    const renderCitation = () => {
        if (!selectedPublication || !selectedFormat) return 'Please select a format.';
        return citationFormats[selectedFormat](selectedPublication);
    };

    const [parentTitles, setParentTitles] = useState({});
    const [selectedPublication, setSelectedPublication] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedFormat, setSelectedFormat] = useState('');
    const fetchParentTitles = async (initialParentId) => {
        let currentParentId = initialParentId;
        let titles = [];

        while (currentParentId) {
            try {
                console.log("whilepcalleddd")
                const response = await axiosInstance.get(
                    `publications/publicationdetail/${currentParentId}/-1`,
                    {
                        headers: {
                            Authorization: `Bearer ${auth.token}`,
                        },
                    }
                );

                if (response.data && response.data.data.elasticjson) {
                    const title =
                        response.data.data.publicationtypeInfo.find(
                            (attr) => attr.attributename === "Başlık"
                        )?.value[0]?.value[0] ||
                        response.data.data.templateInfo.find(
                            (attr) => attr.attributename === "Başlık"
                        )?.value[0]?.value[0] ||
                        response.data.data.publicationtypeInfo.find(
                            (attr) => attr.attributename === "Dergi Adı"
                        )?.value[0]?.value[0] ||
                        response.data.data.templateInfo.find(
                            (attr) => attr.attributename === "Dergi Adı"
                        )?.value[0]?.value[0] ||
                        "-";

                    titles.unshift(title);
                    currentParentId = response.data.data.parentid;
                } else {
                    break;
                }
            } catch (error) {
                console.error(`Error fetching parent title for ${currentParentId}:`, error);
                break;
            }
        }

        return titles.join(" / ");
    };
    useEffect(() => {
        const loadParentTitles = async () => {
            for (let pub of publications) {
                const parentId = pub.elasticjson?.parentid;
                if (parentId && !parentTitles[parentId]) {
                    const titles = await fetchParentTitles(parentId);
                    setParentTitles((prevTitles) => ({
                        ...prevTitles,
                        [pub.mysqlId]: titles,
                    }));
                }
            }
        };

        loadParentTitles();
    }, [publications]);

    useEffect(() => {
        const fetchPublisherNames = async () => {
            if (publication?.publishers && publication.publishers.length > 0) {
                const infos = await Promise.all(
                    publication.publishers.map(async (pub) => {
                        try {
                            const res = await publisherDetail(pub.mysqlId, 1, auth.token);
                            return {
                                id: pub.mysqlId,
                                name: res?.data?.title || res?.data?.name || '-',
                                shortName: res?.data?.sorttitle
                            };
                        } catch {
                            return { id: pub.mysqlId, name: '-', shortName: null };
                        }
                    })
                );
                setPublisherInfos(infos);
            } else {
                setPublisherInfos([]);
            }
        };
        fetchPublisherNames();
    }, [publication, auth.token]);


    const pubtype = publication?.publicationtype;

    // PDF / erişim hesaplama (PublicationCard ile tutarlı davranış)
    const isOpenAccess = publication?.openaccess === 1 || publication?.openaccess === "1" || publication?.openaccess === true;
    const hasInstitutionAccess = Array.isArray(publication?.databases) && publication.databases.some(db => {
        const name = db?.name;
        const id = db?.mysqlId ?? db?.id;
        return (name && userDatabase.includes(name)) || (id && userDatabase.includes(String(id)));
    });
    const isAccessible = isOpenAccess || hasInstitutionAccess;
    const pdfLink = publication?.pdffile ? (publication.openaccess === 1 ? `/view-pdf/${publication?.mysqlId}` : `/view-pdf-protectedaccess/${publication?.mysqlId}`) : null;

    // SEO related: canonical + Google Scholar meta + JSON-LD
    const canonical = publication ? window.location.origin + buildPublicationPath({ title: (publication?.publicationtypeInfo?.find(a => a.attributename === "Başlık")?.value?.[0]?.value?.[0]) || publication?.templateInfo?.find(a => a.attributename === "Başlık")?.value?.[0]?.value?.[0] || publication?.title || "", id: publication?.mysqlId || id }) : null;



    // "Dergi Sayısı" kontrolü (yalnızca "Sayısı" kelimesine bak)
    const isJournalIssue = Boolean(
        (publicationType && publicationType.includes("Sayısı")) ||
        (pubtype && pubtype.includes("Sayısı"))
    );

    // issue ise derginin kendisi kaynaktır, değilse publication
    const aboutSource = (isJournalIssue && parentJournal) ? parentJournal : publication;

    // aktif dil
    const availableLanguages = getAvailableLanguages(aboutSource);
    const [activeTab, setActiveTab] = useState(availableLanguages[0] || "tr");

    useEffect(() => {
        const langs = getAvailableLanguages(aboutSource);
        if (!langs.includes(activeTab)) setActiveTab(langs[0] || "tr");
    }, [aboutSource]); // eslint-disable-line

    // başlık (artık aboutSource üzerinden)
    const titleData = React.useMemo(() => {
        const titles = getValidTitles(publication, "Başlık");
        if (titles.length === 0) return { primary: null, secondary: null };

        // 1- Önce kullanıcının aktif dilinde (activeTab) "dolu" bir başlık var mı diye bak:
        const activeLangTitle = activeTab ? titles.find(t => t.lang === String(activeTab).toLowerCase()) : null;

        // 2- Eğer aktif dilde dolu başlık varsa onu al, yoksa array'deki ilk "dolu" başlığı al:
        const primaryTitleObj = activeLangTitle || titles[0];
        const primary = primaryTitleObj.title;

        // 3- İkinci başlık: Birinci başlıktan farklı olan ilk dolu başlığı al
        const secondaryTitleObj = titles.find(t => t.title.toLowerCase() !== primary.toLowerCase());
        const secondary = secondaryTitleObj?.title || null;

        return { primary, secondary };
    }, [publication, activeTab]);

    const title = titleData.primary;
    const secondTitle = titleData.secondary;

    // console.log(secondTitle);

    // tüm meta alanlarını tek obje altında topla
    const journalMeta = React.useMemo(() => {
        const ej = aboutSource;
        const { authors: peopleAuthors, editors: peopleEditors } = splitPeopleByJob(ej?.authors);
        return {
            journalTitle: getField(ej, "Başlık", activeTab) || parentDetails?.title || null,
            issn: getField(ej, "ISSN"),
            eIssn: getField(ej, "E-ISSN"),
            accessType: deriveAccessType(ej),
            editorTr: (ej?.publicationtypeInfo || ej?.templateInfo)
                ?.find(a => a.attributename === "Editör")
                ?.value?.find(v => v.lang === "tr")?.value?.[0] || null,
            editors: peopleEditors,
            audience: getField(ej, "Okuyucu Kitlesi"),
            webAddress: getField(ej, "Web Adresi"),
            publishers: getPublishersPretty(publisherInfos, parentDetails?.publisher || ej?.publishers),
            authors: peopleAuthors,
            publishDate: getField(ej, "Son Yayınlandığı Tarih") || getField(ej, "Yayın Tarihi") || null,
            databases: databasesPretty(ej), // ⬅️ artık dinamik map’i kullanıyor
            keywords: getField(ej, "Anahtar Kelimeler"),
            navigate: navigate,
        };
    }, [aboutSource, activeTab, publisherInfos, parentDetails, databasesPretty]);

    // getField, deriveAccessType, databasesPretty zaten var
    const bookMeta = React.useMemo(() => {
        const ej = publication || {};
        const { authors: peopleAuthors, editors: peopleEditors, translator: peopleTranslators } = splitPeopleByJob(ej?.authors);
        return {
            bookTitle: getField(ej, "Başlık", activeTab),
            authors: peopleAuthors,
            editorsTr:
                (ej.publicationtypeInfo || ej.templateInfo)?.find(a => a.attributename === "Editör")
                    ?.value?.find(v => v.lang === "tr")?.value?.[0] || null,
            editors: peopleEditors,
            publishers: getPublishersPretty(publisherInfos, ej.publishers),
            publishDate: getField(ej, "Yayın Tarihi"),
            isbn: getField(ej, "ISBN"),
            eIsbn: getField(ej, "E-ISBN"),
            doi: getField(ej, "DOI"),
            volume: getField(ej, "Cilt") || parentDetails?.volume,
            issue: getField(ej, "Sayı") || parentDetails?.issue,
            language: getField(ej, "Yayın Dili"),
            firstPage: getField(ej, "İlk Sayfa"),
            lastPage: getField(ej, "Son Sayfa"),
            pageCount: getField(ej, "Sayfa Sayısı"),
            editionInfo: getField(ej, "Baskı Bilgisi"),
            seriesTitle: getField(ej, "Dizi Adı"),
            accessType: deriveAccessType(ej),
            databases: databasesPretty(ej),
            webAddress: getField(ej, "Web Adresi"),
            translator: peopleTranslators,
            journalTitle: parentDetails?.title || null,
            journalId: parentDetails?.mysqlId || null,
            keywords: getField(ej, "Anahtar Kelimeler"),
            publicationType: ej.publicationtype,
            navigate: navigate,
        };
    }, [publication, activeTab, publisherInfos, databasesPretty, parentDetails]);

    // Google Scholar & Enhanced JSON-LD metadata computation
    const scholarMeta = React.useMemo(() => {
        if (!publication) return null;

        const mainTitle = title || bookMeta.bookTitle || journalMeta.journalTitle || publication?.title || "";
        
        // Authors formatting: Google Scholar prefers "Surname, Name" or "Name Surname"
        const authorsList = (bookMeta.authors?.length ? bookMeta.authors : (journalMeta.authors?.length ? journalMeta.authors : publication?.authors)) || [];
        const formattedAuthors = authorsList.map(a => {
            if (typeof a === 'string') return a;
            if (a?.surname && a?.name) return `${a.surname}, ${a.name}`;
            if (a?.name) return a.name;
            return null;
        }).filter(Boolean);

        const jTitle = bookMeta.journalTitle || journalMeta.journalTitle || parentDetails?.title || publication?.publishers?.[0]?.title || "";
        const pubDate = bookMeta.publishDate || journalMeta.publishDate || getField(publication, "Yayın Tarihi") || getField(publication, "Son Yayınlandığı Tarih") || "";
        const volumeVal = bookMeta.volume || parentDetails?.volume || getField(publication, "Cilt") || "";
        const issueVal = bookMeta.issue || parentDetails?.issue || getField(publication, "Sayı") || "";
        const firstPageVal = bookMeta.firstPage || getField(publication, "İlk Sayfa") || "";
        const lastPageVal = bookMeta.lastPage || getField(publication, "Son Sayfa") || "";
        const doiVal = bookMeta.doi || getField(publication, "DOI") || "";
        const issnVal = journalMeta.issn || journalMeta.eIssn || parentDetails?.issn || getField(publication, "ISSN") || getField(publication, "E-ISSN") || "";
        const isbnVal = bookMeta.isbn || bookMeta.eIsbn || getField(publication, "ISBN") || getField(publication, "E-ISBN") || "";
        const fullPdfUrl = pdfLink ? `${window.location.origin}${pdfLink}` : null;

        return {
            title: mainTitle,
            authors: formattedAuthors,
            journalTitle: jTitle,
            pubDate,
            volume: volumeVal,
            issue: issueVal,
            firstPage: firstPageVal,
            lastPage: lastPageVal,
            doi: doiVal,
            issn: issnVal,
            isbn: isbnVal,
            pdfUrl: fullPdfUrl,
        };
    }, [publication, title, bookMeta, journalMeta, parentDetails, pdfLink]);

    const scholarlyLd = React.useMemo(() => {
        if (!publication) return null;

        const mainTitle = title || bookMeta.bookTitle || journalMeta.journalTitle || publication?.title || undefined;
        const description = publication?.abstract || publication?.summary || publication?.publicationtypeInfo?.find(a => a.attributename === "Açıklama")?.value?.[0]?.value?.[0]
            || publication?.templateInfo?.find(a => a.attributename === "Açıklama")?.value?.[0]?.value?.[0] || undefined;
        
        const authorsList = (bookMeta.authors?.length ? bookMeta.authors : (journalMeta.authors?.length ? journalMeta.authors : publication?.authors)) || [];
        const authorPersons = authorsList.map(a => {
            const nameStr = typeof a === 'string' ? a : `${a?.name || ''} ${a?.surname || ''}`.trim();
            return nameStr ? { "@type": "Person", "name": nameStr } : null;
        }).filter(Boolean);

        const publisherName = publisherInfos?.[0]?.name || publication?.publishers?.[0]?.title || publication?.publishername || undefined;

        let schemaType = "ScholarlyArticle";
        const typeStr = String(pubtype || "").toLowerCase();
        if (typeStr.includes("kitap") && !typeStr.includes("bölümü")) {
            schemaType = "Book";
        } else if (typeStr === "dergi") {
            schemaType = "Periodical";
        }

        const ldObj = {
            "@context": "https://schema.org",
            "@type": schemaType,
            "name": mainTitle,
            "headline": mainTitle,
            "description": description,
            "url": canonical,
            "author": authorPersons.length ? authorPersons : undefined,
            "publisher": publisherName ? { "@type": "Organization", "name": publisherName } : undefined,
            "datePublished": scholarMeta?.pubDate || undefined,
            "volumeNumber": scholarMeta?.volume || undefined,
            "issueNumber": scholarMeta?.issue || undefined,
            "pageStart": scholarMeta?.firstPage || undefined,
            "pageEnd": scholarMeta?.lastPage || undefined,
            "isPartOf": scholarMeta?.journalTitle ? { "@type": "Periodical", "name": scholarMeta.journalTitle } : undefined,
        };

        if (scholarMeta?.doi) {
            ldObj.sameAs = `https://doi.org/${scholarMeta.doi}`;
        }

        if (scholarMeta?.isbn) {
            ldObj.isbn = scholarMeta.isbn;
        }

        if (scholarMeta?.issn) {
            ldObj.issn = scholarMeta.issn;
        }

        return ldObj;
    }, [publication, title, bookMeta, journalMeta, publisherInfos, pubtype, canonical, scholarMeta]);



    // parent dergi id (önce immediate parent, yoksa eldeki)
    const parentJournalId = publication?.parentid || parentDetails?.mysqlId || id;

    // Issue başlığı: önce "Başlık", yoksa Cilt/Sayı
    const vol = publication?.publicationtypeInfo?.find(a => a.attributename === "Cilt")?.value?.[0]?.value?.[0];
    const iss = publication?.publicationtypeInfo?.find(a => a.attributename === "Sayı")?.value?.[0]?.value?.[0];
    const issueTitleFromFields =
        publication?.publicationtypeInfo?.find(a => a.attributename === "Başlık")?.value?.[0]?.value?.[0] ||
        publication?.templateInfo?.find(a => a.attributename === "Başlık")?.value?.[0]?.value?.[0];
    const issueHeader = issueTitleFromFields || [vol && `Cilt ${vol}`, iss && `Sayı ${iss}`].filter(Boolean).join(" / ") || "Bu Sayı";

    // Web Adresi'ni çek
    const webAddress =
        aboutSource?.templateInfo
            ?.find(attr => attr.attributename === "Web Adresi")
            ?.value?.[0]?.value?.[0] || null;

    // Tab içeriklerinde fade animasyonu için yardımcı fonksiyon
    function getTabContentClass(isActive) {
        return `tab-pane fade${isActive ? ' show active' : ''}`;
    }
    const [activeMainTab, setActiveMainTab] = useState(
        () => (location.state?.openTab === "buSayi" ? "buSayi" : "sonSayi")
    );

    // "Sayısı" kontrolün zaten var: isJournalIssue
    useEffect(() => {
        if (isJournalIssue || location.state?.openTab === "buSayi") {
            setActiveMainTab("buSayi");
            // state'i temizle (tekrar renderlarda taşınmasın)
            if (location.state?.openTab) {
                navigate(location.pathname, { replace: true, state: {} });
            }
        }
    }, [isJournalIssue, location.state, navigate, location.pathname]);

    const showJournalPublishDate = pubtype === "Dergi" && !isJournalIssue;


    const articleTypeForJournal =
        (publicationAudience || "").includes("genel") ? "Popüler Dergi Yazısı" : "Akademik Makale";

    const articleTypeForIssue =
        (parentDetails?.audience || "").toLowerCase().includes("genel") ? "Popüler Dergi Yazısı" : "Akademik Makale";

    // Kapak resmi URL'sini oluştur - ARTIK latestIssueId'yi kullan
    const coverImageUrl = useMemo(() => {
        // Eğer dergi sayfasındaysak ve latestIssueCover varsa, onu kullan
        if (pubtype === "Dergi" && latestIssueCover && latestIssueId) {
            return getFilePath(`publications/search/displayFile/${latestIssueId}/${latestIssueCover}`);
        }

        // Diğer durumlarda (dergi sayısı, kitap vb.) kendi kapak resmini kullan
        if (publication?.coverimage) {
            return getFilePath(`publications/search/displayFile/${publication?.mysqlId}/${publication?.coverimage}`);
        }

        // ⬇️ Fallback: Eğer makale/bölüm ise ve kendi kapağı yoksa, parent (sayı/dergi/kitap) kapağını kullan
        if (parentDetails?.coverimage && parentDetails?.mysqlIdForCover) {
            return getFilePath(`publications/search/displayFile/${parentDetails.mysqlIdForCover}/${parentDetails.coverimage}`);
        }

        return Video;
    }, [latestIssueCover, latestIssueId, publication, pubtype, parentDetails]);

    // Kapak resmi güncelleme fonksiyonu
    const handleCoverImageUpdate = (coverImage, issueId) => {
        setLatestIssueCover(coverImage);
        setLatestIssueId(issueId);
    };

    return (
        <>
            {publication && (
                <Helmet>
                    <title>{`${title} | Yayın`}</title>
                    {canonical && <link rel="canonical" href={canonical} />}
                    <meta name="description" content={publication?.abstract || publication?.summary || (title || '')} />
                    <meta property="og:type" content="article" />
                    <meta property="og:title" content={title} />
                    {canonical && <meta property="og:url" content={canonical} />}

                    {/* Google Scholar Meta Tags */}
                    {scholarMeta?.title && <meta name="citation_title" content={scholarMeta.title} />}
                    {scholarMeta?.authors?.map((author, idx) => (
                        <meta key={idx} name="citation_author" content={author} />
                    ))}
                    {scholarMeta?.journalTitle && <meta name="citation_journal_title" content={scholarMeta.journalTitle} />}
                    {scholarMeta?.pubDate && <meta name="citation_publication_date" content={scholarMeta.pubDate} />}
                    {scholarMeta?.volume && <meta name="citation_volume" content={scholarMeta.volume} />}
                    {scholarMeta?.issue && <meta name="citation_issue" content={scholarMeta.issue} />}
                    {scholarMeta?.firstPage && <meta name="citation_firstpage" content={scholarMeta.firstPage} />}
                    {scholarMeta?.lastPage && <meta name="citation_lastpage" content={scholarMeta.lastPage} />}
                    {scholarMeta?.doi && <meta name="citation_doi" content={scholarMeta.doi} />}
                    {scholarMeta?.issn && <meta name="citation_issn" content={scholarMeta.issn} />}
                    {scholarMeta?.isbn && <meta name="citation_isbn" content={scholarMeta.isbn} />}
                    {scholarMeta?.pdfUrl && <meta name="citation_pdf_url" content={scholarMeta.pdfUrl} />}

                    {scholarlyLd && (
                        <script type="application/ld+json">{JSON.stringify(scholarlyLd)}</script>
                    )}
                </Helmet>
            )}
            <div className="main-wrapper">
                <Header />


                <div className="breadcrumb-bar ">
                    <div className="container">
                        <div className="row">articleTypeOverride={articleTypeForJournal}
                            <div className="col-md-12 col-12">
                            </div>
                        </div>
                    </div>
                </div>


                <section className="page-content course-sec">
                    <div className="container compact-content">
                        <div className="feature-sec">
                            <div>
                                <div className="row align-items-start gy-3">
                                    <div className="col-12 col-md-4 d-flex justify-content-center align-items-start mb-3 mb-md-0">
                                        <div
                                            className="video-sec vid-bg p-0 w-100"
                                            style={{
                                                maxWidth: 260,
                                                cursor: 'zoom-in' // Büyütülebilir olduğunu belirtmek için imleç değişimi
                                            }}
                                            onClick={() => setShowImageModal(true)} // Tıklanınca aç
                                        >
                                            <img
                                                src={coverImageUrl}
                                                alt=""
                                                className="img-fluid w-100"
                                                style={{
                                                    objectFit: 'contain',
                                                    width: '100%',
                                                    height: '220px',
                                                    maxHeight: '220px',
                                                    background: 'none',
                                                    boxShadow: 'none',
                                                    borderRadius: '12px',
                                                    display: 'block',
                                                    margin: '0 auto'
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-8" style={{ fontSize: '0.93em' }}>
                                        <div className="cat-title small fs-5 mb-2">
                                            <h5 className="fw-semibold fs-5 mb-1 mt-1 text-fume small">
                                                {!publication ? (
                                                    <div className="d-flex align-items-center my-3">
                                                        <Spinner animation="border" size="sm" className="me-2" />
                                                        <span>Yükleniyor...</span>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        {pubtype && (
                                                            <div className="me-2 mb-1 d-inline-block text-fume" style={{ fontSize: '0.65em' }}>
                                                                {String(pubtype).toLowerCase().includes("kitap") && !String(pubtype).toLowerCase().includes("bölümü")
                                                                    ? "Kitap"
                                                                    : (pubtype === "Bildiri" ? "Konferans ve Armağan Yazısı" : pubtype)
                                                                }
                                                            </div>
                                                        )}
                                                        {/* Ana başlık ve PDF butonu aynı satırda */}
                                                        <div style={{ display: 'flex', gap: 8, marginBottom: secondTitle ? '4px' : '0' }}>
                                                            <span style={{ display: 'inline-block' }}>{title}</span>
                                                            {pdfLink && (
                                                                <button
                                                                    className="btn-sm border-0 bg-transparent d-inline-flex mt-1"
                                                                    style={{ fontSize: "0.88rem", color: isAccessible ? '#616469' : '#b0b0b0' }}
                                                                    onClick={() => window.open(pdfLink, "_blank", "noopener,noreferrer")}
                                                                    title={"PDF'i görüntüle"}
                                                                    aria-label="PDF görüntüle"
                                                                >
                                                                    <PdfAcrobatIcon size={18} />
                                                                </button>
                                                            )}
                                                        </div>
                                                        {/* İkinci başlık alt satırda */}
                                                        {secondTitle && (
                                                            <div className="text-muted text-xs" style={{ marginTop: '2px' }}>
                                                                ({secondTitle})
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </h5>
                                        </div>
                                        <div className="p-2 d-flex flex-column h-100">
                                            {/* Bilgi kutusu: başlık+span blokları */}
                                            <div className="mb-2">
                                                {(pubtype === "Akademik Kitap" || pubtype === "Popüler Kitap" || pubtype === "Konferans ve Armağan")
                                                    ? (
                                                        // KİTAP HEADER
                                                        <BookHeaderInfo meta={bookMeta} />
                                                    )
                                                    : (pubtype === "Akademik Makale" || pubtype === "Popüler Dergi Yazısı" || pubtype === "Akademik Kitap Bölümü" || pubtype === "Konferans ve Armağan Yazısı" || pubtype === "Bildiri")
                                                        ? (
                                                            // SUBPUB (MAKALE VS) HEADER
                                                            <SubPubHeaderInfo meta={bookMeta} />
                                                        )
                                                        : (
                                                            // DERGİ / SAYI HEADER
                                                            <JournalHeaderInfo
                                                                meta={journalMeta}
                                                                parentId={isJournalIssue ? parentJournalId : parentDetails?.mysqlId}
                                                                showPublishDate={showJournalPublishDate}
                                                                hidePeople={isJournalIssue}
                                                            />
                                                        )}
                                                {/* Issue özel alanları (Yayın Tarihi, Cilt/Sayı) gerekiyorsa bunları JournalHeaderInfo altına ek bırak */}
                                                {isJournalIssue && (
                                                    <>
                                                        {(
                                                            publication?.publicationtypeInfo?.find(a => a.attributename === "Yayın Tarihi")?.value?.find(v => v.lang === "tr")?.value?.[0] ||
                                                            publication?.templateInfo?.find(a => a.attributename === "Yayın Tarihi")?.value?.find(v => v.lang === "tr")?.value?.[0]
                                                        ) && (
                                                                <div className="mb-1 d-flex align-items-center">
                                                                    <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>Yayın Tarihi:</span>
                                                                    <span className="text-fume">
                                                                        {publication?.publicationtypeInfo?.find(a => a.attributename === "Yayın Tarihi")?.value?.find(v => v.lang === "tr")?.value?.[0] ||
                                                                            publication?.templateInfo?.find(a => a.attributename === "Yayın Tarihi")?.value?.find(v => v.lang === "tr")?.value?.[0]}
                                                                    </span>
                                                                </div>
                                                            )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>

                        {/* --- Dergi olmayanlarda sadece JournalAbout göster --- */}
                        {pubtype !== "Dergi" && !isJournalIssue && (
                            <div className="row">
                                <div className="col-12">
                                    <div className="feature-sec">
                                        {(pubtype === "Akademik Kitap" || pubtype === "Popüler Kitap" || pubtype === "Konferans ve Armağan") ? (
                                            <BookAbout
                                                publication={publication}
                                                similarPublications={similarPublications}
                                                authToken={auth.token}
                                                parentDetails={parentDetails}
                                                pubtype={pubtype}
                                                activeTab={activeTab}
                                                availableLanguages={availableLanguages}
                                                setActiveTab={setActiveTab}
                                                webAddress={webAddress}
                                                navigate={navigate}
                                                initialMainTab="icindekiler"
                                            />
                                        ) : (pubtype === "Akademik Makale" || pubtype === "Popüler Dergi Yazısı" || pubtype === "Akademik Kitap Bölümü" || pubtype === "Konferans ve Armağan Yazısı" || pubtype === "Bildiri") ? (
                                            <SubPubAbout
                                                publication={publication}
                                                similarPublications={similarPublications}
                                                authToken={auth.token}
                                                navigate={navigate}
                                                pubtype={pubtype}
                                                parentDetails={parentDetails}
                                            />
                                        ) : (
                                            <JournalAbout
                                                publication={publication}
                                                latestYear={absoluteLatestYear}
                                                parentDetails={parentDetails}
                                                pubtype={pubtype}
                                                activeTab={activeTab}
                                                availableLanguages={availableLanguages}
                                                setActiveTab={setActiveTab}
                                                webAddress={webAddress}
                                                navigate={navigate}
                                                accessType={journalMeta.accessType}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* --- Dergi ise tablı yapı ve mevcut kodu koru --- */}
                        {pubtype === "Dergi" && (
                            <div className="feature-sec">
                                <div className="card-header">
                                    <ul className="nav nav-tabs mb-2">
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link btn-sm small${activeMainTab === "sonSayi" ? " fw-semibold text-primary" : " text-muted"}`}
                                                style={{ fontSize: '1em' }}
                                                onClick={() => setActiveMainTab("sonSayi")}
                                            >
                                                Son Sayı
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link btn-sm small${activeMainTab === "arsiv" ? " fw-semibold text-primary" : " text-muted"}`}
                                                style={{ fontSize: '1em' }}
                                                onClick={() => setActiveMainTab("arsiv")}
                                            >
                                                Arşiv
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link btn-sm small${activeMainTab === "dergiHakkinda" ? " fw-semibold text-primary" : " text-muted"}`}
                                                style={{ fontSize: '1em' }}
                                                onClick={() => setActiveMainTab("dergiHakkinda")}
                                            >
                                                Dergi Hakkında
                                            </button>
                                        </li>
                                    </ul>
                                    {/* --- TABLARA GÖRE KOŞULLU RENDER --- */}
                                    <div className={getTabContentClass(activeMainTab === "sonSayi")}>
                                        {activeMainTab === "sonSayi" && (
                                            <div className="mt-3 mx-3">
                                                <LatestIssue
                                                    publicationId={id}
                                                    onLatestYearFound={setAbsoluteLatestYear}
                                                    publicationType={publicationType}
                                                    onCite={handleOpenModal}
                                                    onAddToLibrary={handleSingleSaveWithModal}
                                                    favoriteSavedIds={favoriteSavedIds}
                                                    setFavoriteSavedIds={setFavoriteSavedIds}
                                                    userinstDatabases={userDatabase}
                                                    articleTypeOverride={articleTypeForJournal}
                                                    onCoverImageUpdate={handleCoverImageUpdate}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div className={getTabContentClass(activeMainTab === "arsiv")}>
                                        {activeMainTab === "arsiv" && pubtype != "Konferans ve Armağan Yazısı" && (
                                            <div className="mt-3 mx-3">
                                                <PreviousIssues
                                                    publicationId={id}
                                                    publicationType={publicationType}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div className={getTabContentClass(activeMainTab === "dergiHakkinda")}>
                                        {activeMainTab === "dergiHakkinda" && (
                                            <div>
                                                <JournalAbout
                                                    publication={parentJournal || publication}   // ⬅️ parent dergi
                                                    latestYear={absoluteLatestYear}
                                                    parentDetails={parentDetails}
                                                    pubtype={"Dergi"}
                                                    activeTab={activeTab}
                                                    availableLanguages={availableLanguages}
                                                    setActiveTab={setActiveTab}
                                                    webAddress={webAddress}                      // ⬅️ parent’tan gelen adres
                                                    navigate={navigate}
                                                    accessType={journalMeta.accessType}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                        {isJournalIssue && (
                            <div className="feature-sec">
                                <div className="card-header">
                                    <ul className="nav nav-tabs mb-2">
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link btn-sm small${activeMainTab === "buSayi" ? " fw-semibold text-primary" : " text-muted"}`}
                                                style={{ fontSize: '1em' }}
                                                onClick={() => setActiveMainTab("buSayi")}
                                            >
                                                {issueHeader}
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link btn-sm small${activeMainTab === "arsiv" ? " fw-semibold text-primary" : " text-muted"}`}
                                                style={{ fontSize: '1em' }}
                                                onClick={() => setActiveMainTab("arsiv")}
                                            >
                                                Dergi Arşivi
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link btn-sm small${activeMainTab === "dergiHakkinda" ? " fw-semibold text-primary" : " text-muted"}`}
                                                style={{ fontSize: '1em' }}
                                                onClick={() => setActiveMainTab("dergiHakkinda")}
                                            >
                                                Dergi Hakkında
                                            </button>
                                        </li>
                                    </ul>

                                    {/* Tab-1: Bu sayının makaleleri */}
                                    <div className={getTabContentClass(activeMainTab === "buSayi")}>
                                        {activeMainTab === "buSayi" && (
                                            <div className="mt-3 mx-3">
                                                <LatestIssue
                                                    publicationId={parentJournalId}
                                                    onLatestYearFound={setAbsoluteLatestYear}
                                                    publicationType={"Dergi"}
                                                    titleOverride={issueHeader}
                                                    initialIssue={publication}
                                                    onCite={handleOpenModal}
                                                    onAddToLibrary={handleSingleSaveWithModal}
                                                    favoriteSavedIds={favoriteSavedIds}         // <-- EKLE
                                                    userinstDatabases={userDatabase}
                                                    articleTypeOverride={articleTypeForIssue}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    {/* Tab-2: Dergi Arşivi */}
                                    <div className={getTabContentClass(activeMainTab === "arsiv")}>
                                        {activeMainTab === "arsiv" && parentJournalId && (
                                            <div className="mt-3 mx-3">
                                                <PreviousIssues
                                                    publicationId={parentJournalId}
                                                    publicationType={"Dergi"}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    {/* Tab-3: Dergi Hakkında */}
                                    <div className={getTabContentClass(activeMainTab === "dergiHakkinda")}>
                                        {activeMainTab === "dergiHakkinda" && (
                                            <div>
                                                <JournalAbout
                                                    publication={parentJournal || publication} // ⬅️ issue’da da derginin kendisi
                                                    latestYear={absoluteLatestYear}
                                                    parentDetails={parentDetails}
                                                    pubtype={"Dergi"}
                                                    activeTab={activeTab}
                                                    availableLanguages={availableLanguages}
                                                    setActiveTab={setActiveTab}
                                                    webAddress={journalMeta.webAddress}
                                                    navigate={navigate}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}


                    </div>
                </section>
                <ImageModal
                    show={showImageModal}
                    onHide={() => setShowImageModal(false)}
                    imageUrl={coverImageUrl}
                    title={title}
                />
                <SaveModal
                    show={showSaveModal}
                    onHide={() => setShowSaveModal(false)}
                    folders={kaydetFolders}
                    savedFolders={kaydetSelectedFolders}
                    setSavedFolders={setKaydetSelectedFolders}
                    onToggleFolder={handleToggleFolder}
                    onCreateFolder={handleCreateFolder}
                    loading={foldersLoading}
                    saveSummary={saveSummary}
                    onAddSinglePublicationToFolder={handleAddSinglePublicationToFolder}
                />

                <Modal show={showModal} size="xl" onHide={handleCloseModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Alıntıla</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="d-flex flex-column">
                            <label htmlFor="citationFormat" className="mb-2 fw-bold">Alıntı Formatı Seçin:</label>
                            <select
                                id="citationFormat"
                                className="form-select mb-3"
                                value={selectedFormat}
                                onChange={(e) => setSelectedFormat(e.target.value)}
                            >
                                <option value="" disabled>Bir format seçin</option>
                                <option value="bibtex">BibTeX</option>
                                <option value="apa">APA</option>
                                <option value="vancouver">Vancouver</option>
                                <option value="harvard">Harvard</option>
                                <option value="mla">MLA</option>
                                <option value="chicago">Chicago</option>
                                <option value="ieee">IEEE</option>
                            </select>
                        </div>

                        <hr />
                        <h5>Alıntı:</h5>
                        <pre className="bg-light p-3">{renderCitation()}</pre>


                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => navigator.clipboard.writeText(renderCitation())}
                        >
                            Kopyala
                        </Button>
                        {selectedFormat === "bibtex" && (
                            <Button
                                variant="secondary"
                                onClick={() => {
                                    const element = document.createElement("a");
                                    const file = new Blob([renderCitation()], { type: "text/plain" });
                                    element.href = URL.createObjectURL(file);
                                    element.download = "citation.bib";
                                    document.body.appendChild(element);
                                    element.click();
                                }}
                            >
                                BibTeX İndir
                            </Button>
                        )}
                        <Button variant="danger" onClick={handleCloseModal}>
                            Kapat
                        </Button>
                    </Modal.Footer>
                </Modal>


                <Footer2 />
                <ToastContainer position="top-right" autoClose={2500} />

            </div>
        </>
    );
};

export default CourseDetails;
